import * as ScrollUtil from '../utils/scrolling';

/**
 * Form component
 *
 * Funktionen für Formulare.
 */

/**
 * Eine input-active Klasse wird hinzugefügt, sobald ein Input-Feld fokussiert
 * wird oder einen Wert hat.
 * @param {string|Node[]} selectorOrNodes
 */
function steerLabels(selectorOrNodes = '.widget-text input, .widget-textarea textarea') {
    const nodes = typeof selectorOrNodes === 'string' ? document.querySelectorAll(selectorOrNodes) : selectorOrNodes;

    for (const input of nodes) {
        // input.classList.add('steering');

        // Remove active class from label on blur if input is empty
        input.addEventListener('blur', function () {
            if (this.value === '') {
                this.parentNode.querySelector('label').classList.remove('input-active');
            }
        });

        // Add active class to label on focus
        input.addEventListener('focus', function () {
            this.parentNode.querySelector('label').classList.add('input-active');
        });

        // Add active class to label on page load if input is not empty
        if (input.value !== '') {
            input.parentNode?.querySelector('label')?.classList.add('input-active');
        }
    }
}

/**
 * Ensure script will work on input Fields after Ajax reload
 *
 * @param {string} selector
 */
function ajaxFormSteerLabels(selector = '.ce_form') {
    const ajaxForms = [...document.querySelectorAll(selector)].filter((el) => !!el.querySelector('[data-ajax-form]'));

    for (const ce_form of ajaxForms) {
        const observedWrapper = ce_form.querySelector('form').parentElement;

        new MutationObserver((mutationList) => {
            for (const mutation of mutationList) {
                if (mutation.type === 'childList') {
                    steerLabels(observedWrapper.querySelectorAll('.widget-text input, .widget-textarea textarea'));
                    enhanceSelects(observedWrapper); // nach Ajax-Reload ersetzte Selects neu koppeln

                    const focusEl = observedWrapper.querySelector('.error, .form-confirmation');

                    if (focusEl && !ScrollUtil.isInViewport(focusEl)) {
                        ScrollUtil.scrollToTarget(focusEl, -15);
                    }
                }
            }
        }).observe(observedWrapper, { childList: true });
    }
}

/**
 * Browser ohne Customizable Select (Firefox/Safari, Stand FF 153): das native
 * Dropdown-Panel ist per CSS nicht stylebar, und Gecko malt beim Öffnen und beim
 * Hovern eigene System-Highlights ÜBER die option-Styles (grauer Ein-Frame-Blitz
 * beim Aufklappen + Hover-Overlay, Kundenvideo 18.08. — per CSS nicht abstellbar).
 * Choices.js (GRUNDGERUEST §7) ersetzt das native Panel dort durch ein
 * DOM-Dropdown in Website-Optik (Styles: _form_solid.scss, ".choices").
 * Chromium kann ::picker(select), behält den @supports-Weg aus _form_solid.scss
 * und lädt Choices erst gar nicht (dynamischer Import).
 */
async function enhanceSelects(root = document) {
    if (CSS.supports('selector(::picker(select))')) return;

    const selects = [...root.querySelectorAll('.widget-select select')].filter((el) => !el.dataset.choicesEnhanced);

    if (!selects.length) return;

    const { default: Choices } = await import('choices.js');

    for (const select of selects) {
        select.dataset.choicesEnhanced = '1';

        // Label-Verknüpfung geht beim Verstecken des selects verloren — der
        // Choices-Wrapper (role listbox) bekommt sie per aria-labelledby zurück
        const label = select.closest('.widget-select')?.querySelector(`label[for='${select.id}']`);
        if (label && !label.id) {
            label.id = `${select.id}_label`;
        }

        new Choices(select, {
            searchEnabled: false,
            shouldSort: false,
            itemSelectText: '',
            allowHTML: false,
            labelId: label?.id ?? '',
        });
    }
}

/**
 * Wenn Formular-Fehler auf der Seite sind, wird automatisch zum ersten gescrollt
 */
function scrollToErrors() {
    const firstError = document.querySelector('.error');

    ScrollUtil.scrollToTarget(firstError, -15);
}

document.addEventListener('DOMContentLoaded', () => {
    scrollToErrors();
    // Initial steer labels - do not delete
    steerLabels();
    // Steer Labels after Form reload
    ajaxFormSteerLabels();
    // Natives Select-Panel durch Choices.js ersetzen (Firefox/Safari, s. o.)
    enhanceSelects();
});
